import indiaLocations from '../data/india-locations.json';
import { Field } from './Common';

interface LocationFieldsProps {
  idPrefix: string;
  city: string;
  state: string;
  onCityChange: (city: string) => void;
  onStateChange: (state: string) => void;
}

const states = indiaLocations.states;

export function LocationFields({
  idPrefix,
  city,
  state,
  onCityChange,
  onStateChange,
}: LocationFieldsProps) {
  const selectedState = states.find((item) => item.name === state);
  const cities = selectedState?.cities ?? [];
  const cityIsInDataset = cities.some((item) => item === city);
  const stateIsInDataset = states.some((item) => item.name === state);

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <Field label="State / Union territory" htmlFor={`${idPrefix}-state`} required>
          <select
            id={`${idPrefix}-state`}
            className="form-select"
            value={state}
            onChange={(event) => {
              onStateChange(event.target.value);
              onCityChange('');
            }}
            required
          >
            <option value="">Select a state or union territory</option>
            {state && !stateIsInDataset && <option value={state}>Existing: {state}</option>}
            {states.map((item) => (
              <option key={item.name} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
        </Field>
      </div>

      <div className="col-12 col-md-6">
        <Field
          label="City / town"
          htmlFor={`${idPrefix}-city`}
          required
          hint={`${cities.length.toLocaleString()} city/town options. GeoNames (CC BY 4.0) includes populated places over 500 people and administrative seats.`}
        >
          <select
            id={`${idPrefix}-city`}
            className="form-select"
            value={city}
            onChange={(event) => onCityChange(event.target.value)}
            disabled={!state}
            required
          >
            <option value="">{state ? 'Select a city or town' : 'Select a state first'}</option>
            {city && !cityIsInDataset && <option value={city}>Existing: {city}</option>}
            {cities.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </Field>
      </div>
    </div>
  );
}
